import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { FOOTER_LINKS, BRAND, GET_STARTED_URL, ENTERPRISE_DEMO_URL, STARTUPFUEL_URL } from '../../data/dgpt';
import { CtaButton } from '../ui/CtaButton';
import { DgptLogo } from './DgptLogo';
const year = new Date().getFullYear();
export function DgptFooter() {
  const linkClass = 'text-sm font-medium text-text-secondary transition-colors hover:text-text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime focus-visible:ring-offset-4 focus-visible:ring-offset-surface';
  return <footer className="border-t border-hairline bg-surface pb-24 sm:pb-0" data-id="element-20" data-mp="i45w6dl1m03y">
      <div className="mx-auto flex w-full max-w-[1320px] flex-col gap-10 px-4 py-12 sm:px-6 lg:flex-row lg:items-start lg:justify-between lg:px-8" data-id="element-21" data-mp="d5uitsvjh7gz">
        <div className="flex flex-col gap-3" data-id="element-22" data-mp="92y104dtpfe3">
          <DgptLogo data-id="element-23" data-mp="4564sy65b743" />
          <p className="text-sm text-text-secondary" data-id="element-24" data-mp="44wf7bp0j1yx">AI due diligence for investment teams.</p>
        </div>

        <nav aria-label="Footer" data-id="element-25" data-mp="327xvuilpy14q">
          <ul className="flex flex-wrap gap-x-7 gap-y-3" data-id="element-26" data-mp="327o52ssunpxz">
            {FOOTER_LINKS.map(link => <li key={link.label} data-id="element-27" data-mp="371scfd611zzl">
                {link.href.startsWith('/') ? <Link to={link.href} className={linkClass} data-id="element-28" data-mp="2t9vozmfb0e9j">{link.label}</Link> : <a href={link.href} target="_blank" rel="noopener noreferrer" className={linkClass} data-id="element-29" data-mp="2xa5smsfmisl8">{link.label}</a>}
              </li>)}
          </ul>
        </nav>

        <div className="flex flex-col gap-2 sm:flex-row lg:flex-col" data-id="element-30" data-mp="3py1oxw1a6ihh">
          <CtaButton href={GET_STARTED_URL} event="primary_cta_click" eventParams={{
          placement: 'footer',
          cta: 'get_started'
        }} data-id="element-31" data-mp="3bzlk6amzb21z">
            Get Started
            <ArrowRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-32" data-mp="3gzpz3w88noq3" />
          </CtaButton>
          <CtaButton href={ENTERPRISE_DEMO_URL} event="enterprise_demo_click" eventParams={{
          placement: 'footer'
        }} variant="outline" data-id="element-33" data-mp="20lpz6l9e7z2u">
            Book an Enterprise Demo
          </CtaButton>
        </div>
      </div>
      <div className="mx-auto w-full max-w-[1320px] border-t border-hairline-soft px-4 py-6 text-xs text-text-tertiary sm:px-6 lg:px-8" data-id="element-34" data-mp="63eud02k3gts">
        © {year}{' '}
        <a href={STARTUPFUEL_URL} target="_blank" rel="noopener noreferrer" className="font-medium text-text-secondary underline-offset-4 hover:text-text-primary hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-35" data-mp="1b5bg3zuzh10">
          StartupFuel
        </a>
        . {BRAND.product} by StartupFuel.
      </div>
    </footer>;
}